<template>
  <div class="mainContainer">
    <img src="../../assets/rank/bg.png" alt="" class="topBg" />

    <div class="mainContain">
      <div class="navContain">
        <div class="rankList" :class="{ active: rankIndex == index }" v-for="(item, index) in rankList" :key="index"
          @click="topRankClick(index)">
          <div class="activeIconContain">
            <img src="../../assets/rank/left.png" alt="" class="activeIcon" v-if="rankIndex == index" />
          </div>
          <div class="rankListTitle">{{ item.top_name }}</div>
          <div class="activeIconContain">
            <img src="../../assets/rank/right.png" alt="" class="activeIcon" v-if="rankIndex == index" />
          </div>
        </div>
      </div>

      <div class="rankContain">
        <div class="subListContain">
          <el-carousel height="34px" arrow="always" :indicator-position="'none'" :autoplay="false" :loop="false"
            @change="swiperChange">
            <el-carousel-item v-for="(item1, index1) in rankList[rankIndex].navChildren" :key="index1">
              <div class="subList" :class="{ active: subIndex == index }" v-for="(item, index) in item1" :key="index"
                @click="subRankClick(index)">
                {{ item.top_name }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="rankListContain">
          <div class="selectContain">
            <el-select v-model="periodId" placeholder="请选择" @change="getTopDetailList" class="selectPeriod"
              popper-class="selectPeriodPopper">
              <el-option v-for="item in periodList" :key="item.id" :label="item.period_date + ' | ' + item.period_type"
                :value="item.id">
              </el-option>
            </el-select>
            <div class="ruleContain" @click="ruleShow = true">
              <div class="ruleTitle">榜单规则</div>
              <img src="../../assets/rank/rule.png" alt="" class="ruleIcon" />
            </div>
          </div>

          <div class="normalContain" v-if="style_type == 3">
            <div class="normalItem" v-for="(item, index) in rankItems" :key="index">
              <img :src="item.u_avatar" alt="" class="avatar" />
              <div class="introContain">
                <div class="nickName">{{ item.u_nickname }}</div>
                <div class="description" v-if="item.description">{{ item.description }}</div>
              </div>
              <el-popover popper-class="rankPopver" placement="left" width="150" trigger="click"
                @show="codeShow(index + 1)">
                <div class="rankDetailContain">
                  <div :id="'qrCode' + (index + 1)" :ref="'qrCode' + (index + 1)" class="qrcode"></div>
                  <div class="qrcodeText">
                    顶端新闻APP扫码<br />查看详情分享海报
                  </div>
                </div>
                <el-button slot="reference">晒榜</el-button>
              </el-popover>
            </div>
          </div>

          <div class="rankItemsContain" :style="{ paddingTop: style_type != 3 ? '133px' : '0' }" v-else>
            <div class="topThreeContain" v-if="style_type != 3">
              <div class="topThreeItem topOne" :class="{ noCount: style_type == 3 }" v-if="rankItems[0]">
                <img :src="rankItems[0].u_avatar" class="avatar" />
                <div class="nickName">{{ rankItems[0].u_nickname }}</div>
                <div class="score" :style="{ visibility: style_type == 1 ? 'visible' : 'hidden' }">
                  {{ rankItems[0].score }}
                </div>
                <el-popover popper-class="rankPopver" placement="left" width="150" trigger="click" @show="codeShow(1)">
                  <div class="rankDetailContain">
                    <div :id="'qrCode' + 1" :ref="'qrCode' + 1" class="qrcode"></div>
                    <div class="qrcodeText">
                      顶端新闻APP扫码<br />查看详情分享海报
                    </div>
                  </div>
                  <el-button slot="reference">晒榜</el-button>
                </el-popover>
              </div>
              <div class="twoThreeContain">
                <div class="topThreeItem" :class="{ noCount: style_type == 3 }" v-if="rankItems[1]">
                  <img :src="rankItems[1].u_avatar" class="avatar" />
                  <div class="nickName">{{ rankItems[1].u_nickname }}</div>
                  <div class="score" :style="{
                    visibility: style_type == 1 ? 'visible' : 'hidden',
                  }">
                    {{ rankItems[1].score }}
                  </div>
                  <el-popover popper-class="rankPopver" placement="left" width="150" trigger="click"
                    @show="codeShow(2)">
                    <div class="rankDetailContain">
                      <div :id="'qrCode' + 2" :ref="'qrCode' + 2" class="qrcode"></div>
                      <div class="qrcodeText">
                        顶端新闻APP扫码<br />查看详情分享海报
                      </div>
                    </div>
                    <el-button slot="reference">晒榜</el-button>
                  </el-popover>
                </div>
                <div class="topThreeItem" :class="{ noCount: style_type == 3 }" v-if="rankItems[2]">
                  <img :src="rankItems[2].u_avatar" class="avatar" />
                  <div class="nickName">{{ rankItems[2].u_nickname }}</div>
                  <div class="score" :style="{
                    visibility: style_type == 1 ? 'visible' : 'hidden',
                  }">
                    {{ rankItems[2].score }}
                  </div>
                  <el-popover popper-class="rankPopver" placement="left" width="150" trigger="click"
                    @show="codeShow(3)">
                    <div class="rankDetailContain">
                      <div :id="'qrCode' + 3" :ref="'qrCode' + 3" class="qrcode"></div>
                      <div class="qrcodeText">
                        顶端新闻APP扫码<br />查看详情分享海报
                      </div>
                    </div>
                    <el-button slot="reference">晒榜</el-button>
                  </el-popover>
                </div>
              </div>
            </div>
            <el-table :data="style_type == 3 ? rankItems : rankItems.slice(3)">
              <el-table-column width="80" label="排名" v-if="style_type != 3">
                <template slot-scope="{ row }">
                  <div class="count">{{ row.no }}</div>
                </template>
              </el-table-column>
              <el-table-column label="顶端号昵称">
                <template slot-scope="{ row }">
                  <div class="nameContain">
                    <img :src="row.u_avatar" alt="" class="avatar" />
                    <div class="nameContainInner">
                      <div class="nickName">{{ row.u_nickname }}</div>
                      <div class="description" v-if="row.description">{{ row.description }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="140" label="总分" align="center" v-if="style_type == 1">
                <template slot-scope="{ row }">
                  {{ row.score }}
                </template>
              </el-table-column>
              <el-table-column width="130" label="晒榜" align="center">
                <template slot-scope="{ row }">
                  <div class="shareBtnContain">
                    <el-popover popper-class="rankPopver" placement="left" width="150" trigger="click"
                      @show="codeShow(parseInt(row.no))">
                      <div class="rankDetailContain">
                        <div :id="'qrCode' + parseInt(row.no)" :ref="'qrCode' + parseInt(row.no)" class="qrcode"></div>
                        <div class="qrcodeText">
                          顶端新闻APP扫码<br />查看详情分享海报
                        </div>
                      </div>
                      <el-button slot="reference">晒榜</el-button>
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="moreRankItem" v-if="rankItems.length > 3">
              {{ isAll ? "没有更多了" : "加载更多..." }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ruleMask" v-if="ruleShow" @click="ruleShow = false">
      <div class="ruleTextContain" @click.stop="">
        <img src="../../assets/rank/close.png" alt="" class="closeIcon" @click="ruleShow = false" />
        <div class="rules" v-html="rules"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { BI_HOST, SWNEWS_HOST } from "../../constants/apiHosts";
import dbRequest from "../../plugin/request-bd";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      rankIndex: 0,
      rankList: [
        {
          children: [],
        },
      ],
      subIndex: 0,
      periodList: [],
      periodId: "",
      page: 1,
      size: 10,
      isAll: true,
      rankItems: [],
      ruleShow: false,
      rules: "",
      style_type: 1,
    };
  },
  created() {
    this.getTopTree();

    this.trackFn();
  },
  mounted() { },
  methods: {
    trackFn() {
      dbRequest({
        url: `${BI_HOST}/bd`,
        method: "POST",
        params: {
          b_type: "优质顶端号榜单",
        },
      }).then((res) => {
        if (res.data.code == 200) {
        } else {
          //this.$message.error(res.data.msg);
        }
      });
    },
    getTopTree() {
      this.$axios.get(`${SWNEWS_HOST}/api/top/getTopTree`).then((res) => {
        if (res.data.code == 0) {
          res.data.data.forEach((item) => {
            item.navChildren = this.groupBy8(item.children);
          })
          this.rankList = res.data.data;

          this.getTopPeriodList(
            this.rankList[this.rankIndex].children[this.subIndex].id
          );
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    groupBy8(arr) {
      const result = [];
      let currentGroup = [];    // 当前组
      let currentTotal = 0;    // 当前组总字数

      for (const item of arr) {
        // 获取当前元素名字长度（没有则为0）
        const nameLen = item.top_name ? item.top_name.length : 0;

        if (currentTotal + nameLen > 34) {
          // 超了 → 把当前组存入结果，新开组
          result.push([...currentGroup]);
          currentGroup = [item];
          currentTotal = nameLen;
        } else {
          // 没超 → 加入当前组
          currentGroup.push(item);
          currentTotal += nameLen;
        }
      }

      // 最后剩下的组 push 进去
      if (currentGroup.length > 0) {
        result.push(currentGroup);
      }

      return result;
    },
    swiperChange(e) {
      this.subIndex = 0;

      this.getTopPeriodList(
        this.rankList[this.rankIndex].navChildren[e][0].id
      );
    },
    topRankClick(index) {
      this.subIndex = 0;
      this.rankIndex = index;

      this.getTopPeriodList(
        this.rankList[this.rankIndex].children[this.subIndex].id
      );
    },
    subRankClick(index) {
      this.subIndex = index;

      this.getTopPeriodList(
        this.rankList[this.rankIndex].children[this.subIndex].id
      );
    },
    getTopPeriodList(top_id) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/top/getTopPeriodList?top_id=${top_id}&top_pid=${this.rankList[this.rankIndex].id
          }`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.periodList = res.data.data.top_period;

            if (this.periodList.length) {
              this.periodId = this.periodList[0].id;
              this.getTopDetailList();
            } else {
              this.periodId = "";
              this.rankItems = [];
              this.ruleShow = false;
              this.rules = "";
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getTopDetailList() {
      this.ruleShow = false;
      this.periodList.forEach((item) => {
        if (item.id == this.periodId) {
          this.rules = item.rule;
          this.style_type = item.style_type;
        }
      });

      this.$axios
        .get(
          `${SWNEWS_HOST}/api/top/getTopDetailList?top_period_id=${this.periodId}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item, index) => {
              item.no = index + 1 < 10 ? "0" + (index + 1) : index + 1;
            });
            this.rankItems = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    codeShow(index) {
      this.$nextTick(() => {
        let qrCodeElem = document.getElementById("qrCode" + index);
        qrCodeElem.innerHTML = "";
        let qrCode = new QRCode([].concat(this.$refs["qrCode" + index])[0], {
          text:
            (window.location.href.indexOf("dingxinwen.com") > 0 ||
              window.location.href.indexOf("topnews.cn") > 0
              ? "https://m.topnews.cn"
              : "https://m.dingnews.net") +
            `/am/ddTop/index.html#/rank?top_id=${this.rankList[this.rankIndex].children[this.subIndex].id
            }&top_pid=${this.rankList[this.rankIndex].id}`,
          with: 256,
          height: 256,
        });
        qrCode._el.title = "";
      });
    },
  },
};
</script>

<style lang="scss">
.selectPeriodPopper {
  .el-select-dropdown__item {
    color: #333333;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
  }

  .selected {
    background: #fffcf4;
    color: #c87c0e;
  }

  .hover {
    background: #fffcf4;
  }
}


.rankPopver {
  height: 109px !important;
  width: 226px !important;
  min-width: 226px !important;
  background: url("../../assets/rank/codeBg.png") no-repeat;
  background-size: 100% 100%;
  border: 0 !important;
  box-shadow: none !important;
  margin-right: 0 !important;

  .popper__arrow {
    display: none !important;
  }

  .rankDetailContain {
    display: flex;
    align-items: center;

    .qrcode {
      width: 80px;
      height: 80px;
      margin-right: 9px;
    }

    .qrcodeText {
      color: #333333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 400;
      line-height: 17px;
      margin-top: 8px;
    }
  }
}
</style>

<style lang="scss" scoped>
body {
  overflow-x: hidden;
}

.mainContainer {
  background: #F5F5F5;
  position: relative;
  padding: 465px 0 20px 0;
  overflow-x: hidden;

  .topBg {
    width: 1920px;
    height: 534px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -960px;
    max-width: 1920px !important;
  }

  .mainContain {
    width: 1140px;
    margin: 0 auto;
    border-radius: 12px;
    position: relative;
    background: url("../../assets/rank/navBg.png") no-repeat;
    background-size: 100% auto;
    background-color: #fff;
  }

  .navContain {
    display: flex;
    padding: 24px 0;
    justify-content: center;

    .rankList {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0 20px;

      .activeIconContain {
        width: 22px;
      }

      .rankListTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 20px;
        font-weight: 400;
        padding: 0 4px;
      }

      .activeIcon {
        width: 22px;
      }
    }

    .active {
      .rankListTitle {
        color: #c87c0e;
        font-weight: 500;
      }
    }
  }

  .rankContain {
    padding-bottom: 80px;
    position: relative;
    padding: 0 24px;

    .subListContain {
      display: flex;
      flex-wrap: wrap;
      padding: 20px 0;
      border-top: 1px solid #0000001a;
      border-bottom: 1px solid #0000001a;

      .el-carousel {
        width: 1092px;

        .el-carousel__item {
          width: calc(100% - 72px);
          display: flex;
          justify-content: center;
          margin-left: 36px;
          flex-wrap: wrap;
        }

        /deep/.el-carousel__arrow--left {
          background: url("../../assets/rank/arrowLeft.png") no-repeat center;
          background-size: contain;
          left: 0;
          height: 24px;

          .el-icon-arrow-left {
            display: none;
          }
        }

        /deep/.el-carousel__arrow--right {
          background: url("../../assets/rank/arrowRight.png") no-repeat center;
          background-size: contain;
          right: 0;
          height: 24px;

          .el-icon-arrow-right {
            display: none;
          }
        }
      }

      .subList {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 400;
        line-height: 34px;
        padding: 0 16px;
        border-radius: 100px;
        background: #FFF;
        cursor: pointer;
        flex-shrink: 0;
        margin: 0 12px;
      }

      .active {
        background: #FFF0B8;
        color: #C87C0E;
      }
    }

    .rankListContain {
      padding: 89px 88px 34px 88px;
      position: relative;

      .selectContain {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        top: 32px;
        right: 0;

        /deep/.selectPeriod {
          width: 143px;
          border-radius: 4px;
          margin-right: 24px;

          .el-input__inner {
            background: #F6F7F9;
            border: 0;
            color: #666666;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            height: 28px;
            line-height: 28px;
          }

          .el-select__caret {
            background: #F6F7F9;
            color: #666666;
            line-height: 28px;
          }

          .el-input--suffix {
            margin: 0;
          }
        }

        .ruleContain {
          display: flex;
          align-items: center;
          cursor: pointer;

          .ruleTitle {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            margin-right: 3px;
          }

          .ruleIcon {
            height: 20px;
          }
        }
      }

      .normalContain {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 3px;

        .normalItem {
          width: calc(50% - 12px);
          border-radius: 8px;
          background: #F7F7F7;
          padding: 16px;
          margin-bottom: 24px;
          display: flex;
          align-items: center;

          .avatar {
            width: 80px;
            height: 80px;
            border-radius: 100px;
            object-fit: cover;
            margin-right: 16px;
          }

          .introContain {
            flex: 1;

            .nickName {
              width: 210px;
              color: #333333;
              font-family: "PingFang SC";
              font-size: 20px;
              font-weight: 500;
              line-height: 28px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .description {
              width: 210px;
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-top: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .el-button {
            width: 88px;
            height: 38px;
            border-radius: 29.53px;
            border: 0;
            padding: 0 !important;
            margin-left: 16px;

            &:hover,
            &:focus {
              background-color: #fff;
            }

            /deep/span {
              color: #c87c0e;
              text-align: center;
              font-feature-settings: "liga" off, "clig" off;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 400;
            }
          }
        }
      }

      .rankItemsContain {
        position: relative;
        padding-top: 133px;

        .topThreeItem {
          width: 266px;
          height: 339px;
          position: relative;
          padding-top: 82px;
          display: flex;
          flex-direction: column;
          align-items: center;

          .avatar {
            width: 124px;
            height: 124px;
            border-radius: 50%;
            object-fit: cover;
            position: absolute;
            left: 50%;
            top: -56px;
            margin-left: -62px;
          }

          .nickName {
            color: #333333;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 24px;
            font-weight: 500;
            line-height: 50.63px;
            letter-spacing: 0.24p;
          }

          .score {
            color: #666666;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
            line-height: 25px;
            margin-top: 5px;
          }

          .el-button {
            width: 88px;
            height: 42px;
            border-radius: 29.53px;
            border: 1px solid #fff4db;
            padding: 0 !important;
            margin-top: 45px;

            &:hover,
            &:focus {
              background-color: #fff;
            }

            /deep/span {
              color: #c87c0e;
              text-align: center;
              font-feature-settings: "liga" off, "clig" off;
              font-family: "PingFang SC";
              font-size: 20px;
              font-weight: 400;
            }
          }
        }

        .topOne {
          background: url("../../assets/rank/no1.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          left: 50%;
          top: 63px;
          margin-left: -141px;

          .avatar {
            border: 4px solid #ffc55b;
          }
        }

        .topOne.noCount {
          background: url("../../assets/rank/no1no.png") no-repeat;
          background-size: 100% 100%;
        }

        .topThreeContain {
          height: 305px;
        }

        .twoThreeContain {
          display: flex;
          justify-content: space-between;

          .topThreeItem:nth-child(1) {
            background: url("../../assets/rank/no2.png") no-repeat;
            background-size: 100% 100%;

            .avatar {
              border: 4px solid #d8d8d8;
            }
          }

          .topThreeItem:nth-child(1).noCount {
            background: url("../../assets/rank/no2no.png") no-repeat;
            background-size: 100% 100%;
          }

          .topThreeItem:nth-child(2) {
            background: url("../../assets/rank/no3.png") no-repeat;
            background-size: 100% 100%;

            .avatar {
              border: 4px solid #ffa27d;
            }
          }

          .topThreeItem:nth-child(2).noCount {
            background: url("../../assets/rank/no3no.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        .el-table {
          /deep/th {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 400;
            line-height: 49px;

            &:nth-child(2) {
              padding-left: 57px;
            }

            &:nth-last-child(2) {
              padding-left: 0;
            }
          }

          /deep/.el-table__body tr:hover>td {
            background-color: #fff !important;
          }

          /deep/td {
            padding: 17px 0;

            .cell {
              display: flex;
              align-items: center;
            }

            .count {
              color: #e9cb9f;
              font-family: "Source Han Sans CN";
              font-size: 20px;
              font-weight: 500;
            }

            .nameContain {
              display: flex;
              align-items: center;
              width: 100%;

              .avatar {
                width: 68px;
                height: 68px;
                border-radius: 50%;
                object-fit: cover;
                margin-right: 19px;
              }

              .nameContainInner {
                width: calc(100% - 87px);

                .nickName {
                  color: #333333;
                  font-family: "Source Han Sans CN";
                  font-size: 20px;
                  font-weight: 500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                .description {
                  color: #999999;
                  font-family: "PingFang SC";
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 20px;
                  margin-top: 3px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }

            &:nth-child(3) {
              .cell {
                color: #333333;
                font-family: "PingFang SC";
                font-size: 20px;
                font-weight: 400;
                text-align: center;
                justify-content: center;
              }
            }

            &:nth-child(4) {
              .cell {
                justify-content: center;

                .el-button span {
                  color: #C87C0E;
                  text-align: center;
                  font-feature-settings: "liga" off, "clig" off;
                  font-family: "PingFang SC";
                  font-size: 16px !important;
                  font-weight: 400;
                }

                .el-button {
                  width: 80px;
                  height: 38px;
                  border-radius: 100px;
                  background-color: #FFF8ED;
                  padding: 0 !important;
                  border: 0;

                  &:hover,
                  &:focus {
                    background-color: #FFF8ED;
                    border: 0;
                    color: #C87C0E;
                  }
                }
              }
            }

            .shareBtnContain {
              width: 80px;
              display: flex;
              justify-content: center;
              background: #FFF8ED;
              border-radius: 100px;
              overflow: hidden;

              .el-button {
                border: 0;
                background: #FFF8ED;

                span {
                  font-family: "PingFang SC";
                  font-size: 16px;
                  font-weight: 400;
                  color: #C87C0E;
                }
              }
            }
          }
        }

        .moreRankItem {
          color: #999999;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 18px;
          font-weight: 400;
          line-height: 25px;
          cursor: pointer;
          padding-top: 28px;
        }
      }
    }
  }

  .ruleMask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #000000b3;
    z-index: 2;
  }

  .ruleTextContain {
    border-radius: 16px;
    background: url("../../assets/rank/ruleBg.png") no-repeat;
    background-size: 100% auto;
    background-color: #F5F5F5;
    width: 720px;
    height: 90vh;
    padding: 173px 20px 20px 20px;
    position: fixed;
    top: 5vh;
    left: 50%;
    margin-left: -360px;
    display: flex;
    flex-direction: column;

    .closeIcon {
      height: 24px;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    .rules {
      flex: 1;
      min-height: 0;
      border-radius: 16px;
      background: #fff;
      padding: 20px;
      color: #333333;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      white-space: pre-wrap;
      overflow-y: auto;
    }
  }
}
</style>
